import { render, staticRenderFns } from "./RuleTabAction.vue?vue&type=template&id=370a01e3&"
import script from "./RuleTabAction.vue?vue&type=script&lang=ts&"
export * from "./RuleTabAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports